import { render, staticRenderFns } from "./SelectAddress.vue?vue&type=template&id=c1737c16&scoped=true"
import script from "./SelectAddress.vue?vue&type=script&lang=js"
export * from "./SelectAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1737c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1737c16')) {
      api.createRecord('c1737c16', component.options)
    } else {
      api.reload('c1737c16', component.options)
    }
    module.hot.accept("./SelectAddress.vue?vue&type=template&id=c1737c16&scoped=true", function () {
      api.rerender('c1737c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/domestic/SelectAddress.vue"
export default component.exports